import { useState } from "react";

export type DialogType = 'daily' | 'weekly' | 'monthly' | 'yearly';

export interface SalesDialogState {
  showDailyDetails: boolean;
  showWeeklyDetails: boolean;
  showMonthlyDetails: boolean;
  showYearToDateDetails: boolean;
  setShowDailyDetails: (show: boolean) => void;
  setShowWeeklyDetails: (show: boolean) => void;
  setShowMonthlyDetails: (show: boolean) => void;
  setShowYearToDateDetails: (show: boolean) => void;
}

export const useSalesDialogs = (): SalesDialogState => {
  const [showDailyDetails, setShowDailyDetails] = useState(false);
  const [showWeeklyDetails, setShowWeeklyDetails] = useState(false);
  const [showMonthlyDetails, setShowMonthlyDetails] = useState(false);
  const [showYearToDateDetails, setShowYearToDateDetails] = useState(false);

  return {
    showDailyDetails,
    showWeeklyDetails,
    showMonthlyDetails,
    showYearToDateDetails,
    setShowDailyDetails,
    setShowWeeklyDetails,
    setShowMonthlyDetails,
    setShowYearToDateDetails,
  };
};